<template>
  <div class="virtupet-icon" :style="{ width: `${$attrs.size}px`, height: `${$attrs.size}px` }"></div>
</template>

<script>
export default {};
</script>

<style scoped>
.virtupet-icon {
  background-image: url("@/assets/icon.webp");
  background-size: cover;
  background-position: center;
}
</style>
